
export type ServiceAuth = {
    authType: string
}

export type RegFieldChoiceOption = {
    value: string;
    labels?: {[key: string]: string} | null;
};

export type RegField = {
    name: string;
    type: string;
    canPatronEdit: boolean;
    canPatronEditUnderage: boolean;
    required: boolean;
    labels?: {[key: string]: string} | null;
    choiceOptions: RegFieldChoiceOption[] | null;
}

export enum RegFieldName {
  Birthday = "birthday",
  LocalGov = "local_gov",
  LocalGovDate = "local_gov_date",
  MobilePhone = "mobile_phone",
  Email = "email",
  Address = "address",
  FirstName = "first_name",
  LastName = "last_name",
  PersonCode = "person_code",
  Area = "area",
  Profession = "profession"
}

export type RegistrationInfo = {
    registrationCode: string;
    patronName: string;
    type: string;
    regEnabled: boolean;
    regSpecialRights: boolean;
    termsSignature: boolean;
    regUnderage: boolean;
    cancelEnabled: boolean;
    regSignature: boolean;
    cancelSignature: boolean;
    hasPrivacyPolicy: boolean;
    hasServiceTerms: boolean;
    canStaySignedIn: boolean;
    regFields: RegField[];
    /** Global PatronSettingField labels for parent_* — used by hardcoded ParentFormPart. */
    guardianFieldLabels?: { [fieldCode: string]: { [locale: string]: string } } | null;
}

export type ApplicationInfo = {
    name: string;
    appId: string;
    registrationCode: string;
    design: string;
    serviceAuths: ServiceAuth[];
    serviceRegAuths: ServiceAuth[];
    systemNotification: string | null;
    systemNotificationEnabled: boolean;
    infoNotification: string | null;
    infoNotificationEnabled: boolean;
    returnUrl: string | null;
}
